import React, {useState} from 'react';
import type {WithRouterProps} from 'react-router';

import {BadgesAchieved} from './BadgesAchieved';
import type {FilterOption} from './types';
import {FILTER_OPTION} from './types';
import {FilterDropdown} from './FilterDropdown';
import {SkillPathList} from './SkillPathList';
import {useStudentSkillPath} from './hooks/useStudentSkillPath';

export function SkillPath({params}: WithRouterProps) {
  'use memo';

  const classroomId: string | undefined = params?.classroomId;
  const [selectedFilter, setSelectedFilter] = useState<FilterOption>(FILTER_OPTION.TO_DO);

  const {skillSubjectGroups, diagnostics, showDiagnostics, badgeCounts, isLoading, isError, retry} =
    useStudentSkillPath(classroomId, selectedFilter);

  return (
    <div className='student-skill-path flex w-full flex-col'>
      <div className='px-x2 py-x3 m:px-x4 flex items-center justify-between'>
        <FilterDropdown selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} />
        <BadgesAchieved badgeCounts={badgeCounts} />
      </div>
      <SkillPathList
        skillSubjectGroups={skillSubjectGroups}
        diagnostics={diagnostics}
        showDiagnostics={showDiagnostics}
        isLoading={isLoading}
        isError={isError}
        onRetry={retry}
      />
    </div>
  );
}
